<template>
    <div class="toster-wrap success-tost">
        <div class="toster-icon" >
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31ZM6.5 16.6681L12.8927 23.0032L22.6107 13.3729L18.7726 9.5L12.8928 15.3269L10.3381 12.7952L6.5 16.6681Z" fill="white"/>
            </svg>
        </div>
        <div class="toster-content">{{ capitalizeMessage(message) }}</div>
    </div>
</template>
<script>
export default {
    name: "SuccessModal",
    props: ['message'],
    methods:{
        capitalizeMessage(msg){
            if(typeof msg == 'string'){
                msg = msg.trim();
                return msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase();
            }else
                return msg
            
        }
    }
}
</script>